import '@operato/app/filter-renderer.js' /* register resource-object filter renderer */

import { registerEditor as registerGristEditor } from '@operato/data-grist'
import { OxGristEditorFormula } from '@operato/grist-editor/ox-grist-editor-formula.js'

export default function bootstrap() {
  registerGristEditor('formula', OxGristEditorFormula)
}
